'use strict';

var TDChartMarketsAggregationFactory = function TDChartMarketsAggregationFactory(DataAggregationFactory, ExtractMetricKeysService) {
  function TDChartMarketsAggregation() {
    DataAggregationFactory.call(this, ['market-product-group', 'market'], 'thematic-demand-chart-market-markets');
  }
  TDChartMarketsAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  TDChartMarketsAggregation.prototype.canAggregate = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && targetType === this.targetType;
  };
  TDChartMarketsAggregation.constructor = TDChartMarketsAggregation;
  TDChartMarketsAggregation.prototype.aggregate = function (data, metrics) {
    var aggregationFunction = this.getAggregationFunction(metrics);
    var aggregatedMarkets = {};
    var reducedEntry, metricKeys, keysLength, keys;
    for (var index = 0, dataLength = data.length; index < dataLength; index++) {
      if (Array.isArray(aggregatedMarkets[data[index].market])) {
        aggregatedMarkets[data[index].market].push(data[index]);
      } else {
        aggregatedMarkets[data[index].market] = [data[index]];
      }
    }
    if (Object.keys(aggregatedMarkets).length > 0) {
      metricKeys = ExtractMetricKeysService.extract(aggregatedMarkets[Object.keys(aggregatedMarkets)[0]][0]);
    }
    keys = Object.keys(aggregatedMarkets);
    for (index = 0, keysLength = keys.length; index < keysLength; index++) {
      reducedEntry = {};
      reducedEntry.label = keys[index];
      aggregationFunction(aggregatedMarkets[keys[index]], metricKeys, reducedEntry);
      aggregatedMarkets[keys[index]] = reducedEntry;
    }
    return this.sortAggregationResults(aggregatedMarkets);
  };
  return TDChartMarketsAggregation;
};
TDChartMarketsAggregationFactory.$inject = ['DataAggregationFactory', 'ExtractMetricKeysService'];
module.exports = TDChartMarketsAggregationFactory;